import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import type { GlobalMarketDataShape } from '@blockworks/platform/api/research';
import type { PostType } from '@blockworks/platform/api/strapi';
import { Spinner } from '@blockworks/ui';

import { withExceptionCatcher } from '@/components/hoc/with-exception-catcher';
import TokenTransparencyLayout from '@/components/pages/token-transparency/layout/token-transparency-layout';
import { type TokenTransparencyWithTotals } from '@/components/pages/token-transparency/token-transparency-page-static-props';
import { ArticleType } from '@/types/article-type';
import { Category } from '@/utils/functions/wordpress/fetch-categories';
import { WordpressPage } from '@/utils/functions/wordpress/fetch-pages';

export interface TokenTransparencyPageControllerProps {
    tokenTransparencyReports: TokenTransparencyWithTotals[];
    recentResearch: PostType;
    categories: Category[];
    pageContent: WordpressPage | null;
    readMoreArticles: ArticleType[];
    globalMarketHistory: GlobalMarketDataShape[];
    assets: { [key: string]: { imageUrl: string } };
}

const TokenTransparencyPageController = ({
    tokenTransparencyReports,
    recentResearch,
    globalMarketHistory,
    assets,
    pageContent,
}: TokenTransparencyPageControllerProps) => {
    const router = useRouter();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!router.isReady) return;

        setIsLoading(false);
    }, [router.isReady, router.query]);

    if (isLoading) {
        return (
            <div className="flex w-full items-center justify-center min-h-screen">
                <Spinner />
            </div>
        );
    }

    return (
        <TokenTransparencyLayout
            tokenTransparencyReports={tokenTransparencyReports}
            recentResearch={recentResearch}
            globalMarketHistory={globalMarketHistory}
            assets={assets}
            pageContent={pageContent}
        />
    );
};

export default withExceptionCatcher(TokenTransparencyPageController);
